import { render, staticRenderFns } from "./AddingPartModal.vue?vue&type=template&id=1cdb82a1&scoped=true"
import script from "./AddingPartModal.vue?vue&type=script&lang=js"
export * from "./AddingPartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb82a1",
  null
  
)

export default component.exports